import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { useParams } from "react-router-dom";
const EditUser = () => {
    const {id} = useParams();
    
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:''
  });
  const [showAlertMessageOther, setshowAlertMessageOther] = useState({
    status:false,
    message:''
  });
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
  const [formData , setFormData] = useState({})
  const fetchJobs = async ()=>{
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let response = await fetch(`https://api.towrankers.com/api/user/fetch/${id}`, { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
  
      setFormData(data.user)
}
React.useEffect(()=>{
  fetchJobs()
},[1])
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
    
  };
  const onFormSubmit = async (event) =>{
    event.preventDefault();
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       
       let bodyContent = JSON.stringify({
         "name": formData.name,
         "email": formData.email,
         "status":formData.status,
         "role" : formData.role,
       });
       
       let response = await fetch(`https://api.towrankers.com/api/user/update/${formData.id}`, { 
         method: "PUT",
         body: bodyContent,
         headers: headersList
       });
       
    //    let data = await response.text();
     
     let data = await response.json();
     if(response.status == 200){
      setshowAlertMessage({
        message: 'success',
        status:true
      });
      
     }else{


      setshowAlertMessage({
        message: 'error',
        status:true
      });
     }
     
  }
  const onFormSubmitPassword = async (event) =>{
    event.preventDefault();
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let bodyContent = JSON.stringify({
         "currentPassword": event.target.elements.current_password.value,
         "newPassword": event.target.elements.new_password.value,
       });
       
       let response = await fetch(`https://api.towrankers.com/api/user/change-password/${formData.id}`, { 
         method: "PUT",
         body: bodyContent,
         headers: headersList
       });
       
    //    let data = await response.text();
     
     let data = await response.json();
     if(response.status == 200){
      setshowAlertMessageOther({
        message: 'success',
        status:true
      });
     }else{


      setshowAlertMessageOther({
        message: 'error',
        status:true
      });
     }
     
  }
  
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Add User" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
                    {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.message == 'error' ? "Error while adding updating user" : "User Is updated successfully"}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                   

                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          name="fullname"
                          className="form-control radius-8"
                          id="name"
                          value={formData?.name}
                          onChange={(e)=>setFormData((prev)=>({...prev,name:e.target.value}))}
                          placeholder="Enter Full Name"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          name="email_address"
                          className="form-control radius-8"
                          id="email"
                          value={formData?.email}
                          onChange={(e)=>setFormData((prev)=>({...prev,email:e.target.value}))}
                          placeholder="Enter email address"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Role
                        </label>
                         <select 
                          value={formData?.role}
                          onChange={(e)=>setFormData((prev)=>({...prev,role:e.target.value}))} name="role" className="form-control">
                          <option value={'admin'}>Admin</option>
                          <option value={'user'}>User</option>
                         </select>
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Status
                        </label>
                         <select 
                          value={formData?.status}
                          onChange={(e)=>setFormData((prev)=>({...prev,status:e.target.value}))} name="role" className="form-control">
                          <option value={'active'}>Active</option>
                          <option value={'inactive'}>In Active</option>
                         </select>
                      </div>
                      
                     
                    
                    
                   
                      <div className="d-flex align-items-center justify-content-center gap-3">
                     
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save Changes
                        </button>
                      </div>
                      </form>
                      {
                      showAlertMessageOther.status === true?
                    <div
                        className={
                          showAlertMessageOther.message == 'error' ?
                          "mt-20 alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "mt-20 alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessageOther.message == 'error' ? "Please check your current Password" : "Password is changed successfully"}
                        <button type="button" onClick={()=>setshowAlertMessageOther(!showAlertMessageOther)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                      <form onSubmit={(e)=>onFormSubmitPassword(e)}>

                      <div className="mb-20 mt-40">
                        <p style={{fontSize:18,fontWeight:'bold'}}>Change Password</p>
                        </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                         Current  Password
                        </label>
                        <input
                          type="password"

                          name="current_password"
                          className="form-control radius-8"
                          id="email"
                          
                          placeholder="******"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                         New  Password
                        </label>
                        <input
                          type="password"
                          name="new_password"
                          className="form-control radius-8"
                          id="email"
                          
                          placeholder="******"
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-center gap-3">
                     
                     <button
                       type="submit"
                       className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                     >
                       Change Password
                     </button>
                   </div>
                      </form>

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default EditUser;
